import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { AutoCompleteSliceReducer, authReducer, headerReducer, settingsReducer } from "./Services/index";

const rootReducer = combineReducers({
    auth: authReducer,
    AutoComplete: AutoCompleteSliceReducer,
    header: headerReducer,
    settings: settingsReducer,
});

export const store = configureStore({ reducer: rootReducer });